import Vue from "vue";

export const PageComponent = Vue.extend({
  data() {
    return {
      validity: {
        meeting_details: false,
        tutor_contact_info: false
      }
    };
  },

  computed: {
    isValid(): boolean {
      return Object.values(this.validity).every(isValid => isValid);
    }
  },

  methods: {
    updateValidity(
      _: string,
      validity: ValidityState,
      { name }: { name: string }
    ) {
      this.$set(this.validity, name, validity.valid);
    }
  }
});
